// ==============================
// RevenueReportFilter.js (reusing SystemFilterBar with controls/actions)
// ==============================
import React, { useMemo } from "react";
import { useRevenueAnalysis } from "../../Context/Reports/RevenueAnalysisContext";
import SystemFilterBar from "../Common/SystemFilterBar";

const RevenueReportFilter = () => {
  const { openingDate, closingDate, dispatch, getRevenueAnalysis } = useRevenueAnalysis();

  const controls = useMemo(
    () => [
      {
        type: "dateRange",
        labelFrom: "Report Date From",
        labelTo: "Report Date To",
        fromValue: openingDate || "",
        toValue: closingDate || "",
        onChangeFrom: (e) => dispatch({ type: "openingDate", payload: e.target.value }),
        onChangeTo: (e) => dispatch({ type: "closingDate", payload: e.target.value }),
        colClassName: "col-md-6",
      },
      // if you want keyword later:
      // { type:"search", label:"Keyword", value:"", onChange:()=>{}, colClassName:"col-md-3" },
      // if you want selection later:
      // { type:"select", title:"Stream", value:"", onChange:()=>{}, options:[...], placeholder:"-Select-", colClassName:"col-md-3" },
    ],
    [openingDate, closingDate, dispatch]
  );

  const actions = useMemo(
    () => [
      {
        label: "Apply",
        iconClass: "fa fa-filter",
        variant: "primary",
        toggleCollapse: true,
        onClick: () => getRevenueAnalysis(true),
      },
      {
        label: "Reset",
        iconClass: "fa fa-undo",
        variant: "light",
        toggleCollapse: true,
        onClick: () => {
          dispatch({ type: "openingDate", payload: "" });
          dispatch({ type: "closingDate", payload: "" });
        },
      },
    ],
    [dispatch, getRevenueAnalysis]
  );

  return <SystemFilterBar collapseId="revenueReportFilterBar" controls={controls} actions={actions} />;
};

export default RevenueReportFilter;
